import { WEEKDAYS, addDays, fmtDate, todayTR, STATUS } from "@/lib/helpers";
import { Flags } from "./StatusBadge";

function Item({ a, onSelect }) {
  return (
    <button onClick={() => onSelect(a)} data-testid={`calendar-item-${a.request_no}`}
      className={`w-full text-left rounded-xl border p-2.5 transition-[box-shadow,transform] hover:shadow-md hover:-translate-y-0.5 ${
        a.conflict ? "bg-red-50 border-red-500 border-2" : "bg-white border-bej"
      }`}>
      <div className="flex items-center justify-between gap-2">
        <span className="font-heading font-black text-navy">{a.time}</span>
        <span className={`w-2.5 h-2.5 rounded-full ${STATUS[a.status]?.dot}`} title={STATUS[a.status]?.label} />
      </div>
      <p className="mt-0.5 text-sm font-bold text-slate-800 truncate">{a.name}</p>
      <p className="text-xs text-slate-500 truncate">{a.course_name}</p>
      <div className="mt-1.5"><Flags a={a} /></div>
    </button>
  );
}

export function WeekCalendar({ week, items, onSelect }) {
  const today = todayTR();
  const days = Array.from({ length: 7 }, (_, i) => addDays(week, i));
  return (
    <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-7" data-testid="week-calendar">
      {days.map((d, i) => {
        const list = items.filter((a) => a.date === d);
        return (
          <div key={d} className={`rounded-2xl p-3 min-h-[140px] ${d === today ? "bg-bej ring-2 ring-navy/30" : "bg-white border border-bej"}`} data-testid={`calendar-day-${d}`}>
            <div className="mb-3 flex items-baseline justify-between">
              <span className="font-heading font-extrabold text-navy">{WEEKDAYS[i]}</span>
              <span className="text-xs font-bold text-slate-500">{fmtDate(d, { day: "numeric", month: "short" })}</span>
            </div>
            <div className="space-y-2">
              {list.length ? list.map((a) => <Item key={a.id} a={a} onSelect={onSelect} />) : <p className="text-xs text-slate-400">Talep yok</p>}
            </div>
          </div>
        );
      })}
    </div>
  );
}
